/* eslint-disable camelcase */

export default {
  p_requestId: "ID запроса",
  p_requestDate: "Дата запроса",
  p_amount: "Сумма",
  p_paymentSystem: "Платежная система",
  p_status: "Статус",
  p_wallet: "Кошелек",

  status_pending: "Ожидание",
  status_done: "Выполнено",
  status_canceled: "Отменено",
  status_error: "Ошибка",

  status_detail_new: "Новый",
  status_detail_processing: "Обрабатывается",
  status_detail_full_filled: "Выполнен",
  status_detail_completed: "Завершен",
  status_detail_canceled: "Отменен",
  status_detail_error: "Ошибка",

  unknown_error: "Неизвестная ошибка",
  wallet_filter: "Фильтр по кошельку",
  status_filter: "Фильтр по статусу",
  filters_title: "Фильтры",
  clear_all_filters: "Очистить все фильтры",
  active_filters: "Активные фильтры",
  show_filters: "Показать фильтры",
  apply_filters: "Применить фильтры",
  no_filters_active: "Нет активных фильтров",
};
